@if(moodState === 'moodToFill'){
<div class="position-relative" id="{{'item-' + mood.id}}">
    <div class="media card partial-mood" [ngClass]="'card-' + mood.mood" id="{{mood.id}}">
        <div class="card-top card-without-comment-top">
            <div class="card-mood">
                <i [ngClass]="icon"></i>
            </div>
            <div class="card-comment">
                <em class="card-comment-body">{{ 'add_comment_to_mood_placeholder' | translate }}</em>
            </div>

            <div class="card-without-comment-blank"></div>
            <div class="card-add-comment noEditMode" (click)="editMood()">
                <span [ngClass]="'button-' + mood.mood">
                    <i class="fal fa-plus"></i>
                </span>
            </div>
        </div>
    </div>
</div>

} @else if(moodState === 'moodEdit'){
<div class="position-relative" id="{{'item-' + mood.id}}">

    <div class="media card partial-mood" id="{{mood.id}}">
        <div class="card-top">
            <tm-edit-mood-box
                    [mood]="mood"
                    (onEdit)="onMoodEdited($event)"
                    (onCancel)="cancelEdit()"></tm-edit-mood-box>
            <div class="card-blank"></div>
        </div>
    </div>
</div>
} @else if(moodState === 'moodComplete'){

<div class="position-relative" id="{{'item-' + mood.id}}">
    <div class="media card position-relative" id="{{mood.id}}">
            <div class="timeline-item-badge">
                @if(mood.reviewed.length > 0){
                    <review-badge [reviewInfo]="mood.reviewed"></review-badge>
                }
            </div>
            <div class="card-top" (mouseenter)="showTimelineItemOptions=true" (mouseleave)="showTimelineItemOptions=false">
                <div class="card-mood position-relative">
                    <i class="{{ icon}}"></i>
                </div>
                <div class="card-comment">
                    <span class="card-comment-body" [innerHtml]="$safeNavigationMigration(mood.comment?.body) | removeGifUrls: $safeNavigationMigration(mood.comment?.linkPreviews) | linky"></span>
                    @for (linkPreview of mood.comment?.linkPreviews; track linkPreview.url){
                        @if(linkPreview.url.slice(-4) === '.gif'){
                            <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
                        }
                    }
                </div>

                @if(!(isHandset$ | async)){
                <div class="card-options" [ngClass]="{'active-options': showTimelineItemOptions}">
                    @if(mood.isEditable){
                    <div (click)="editMood()">
                        <i class="fa-regular fa-pen"
                           [matTooltip]="'comment-card.options.edit-mood' | translate"
                           matTooltipPosition="right"></i>
                    </div>
                    }
                    @if(mood.isDeletable){
                    <div data-cy="delete-comment" (click)="deleteMood()">
                        <i class="fa-regular fa-trash-alt"
                           [matTooltip]="'comment-card.options.delete-mood' | translate"
                           matTooltipPosition="right"></i>
                    </div>
                    } @else {
                        <div data-cy="report-comment" (click)="reportMood()">
                            <i class="fa-regular fa-hexagon-exclamation"
                               [matTooltip]="'comment-card.options.report' | translate"
                               matTooltipPosition="right"></i>
                        </div>
                    }
                </div>
                } @else {
                    <div class="card-options card-options-mobile">
                        <button class="btn btn-secondary dropdown-toggle" type="button" [matMenuTriggerFor]="menu">
                            <i class="fa-regular fa-ellipsis-vertical"></i>
                        </button>
                        <mat-menu #menu="matMenu">
                            <ul class="p-0 m-0">
                                @if(mood.isEditable){
                                    <li mat-menu-item class="dropdown-item" (click)="editMood()">
                                        <i class="fa-regular fa-pen pe-1"></i> {{'comment-card.options.edit-mood' | translate }}
                                    </li>
                                    }
                                @if(mood.isEditable){
                                    <li mat-menu-item class="dropdown-item" (click)="deleteMood()">
                                        <i class="fa-regular fa-trash-alt pe-1"></i> {{'comment-card.options.delete-mood' | translate }}
                                    </li>
                                } @else {
                                    <li mat-menu-item class="dropdown-item" (click)="reportMood()">
                                        <i class="fa-regular fa-hexagon-exclamation pe-1"></i> {{'comment-card.options.report' | translate }}
                                    </li>
                                }
                            </ul>
                        </mat-menu>
                    </div>
                }
            </div>

            <div class="mx-auto" (mouseenter)="showTimelineItemOptions=true" (mouseleave)="showTimelineItemOptions=false">
                @for(linkPreview of mood.comment?.linkPreviews; track linkPreview.url){
                    @if(linkPreview.url.slice(-4) !== '.gif'){
                        <div>
                            <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
                        </div>
                    }
                }
            </div>
            <div class="media-bottom card-bottom">
                <tm-reactions [timelineItem]="mood"
                              (onReacted)="onReacted($event)"
                              (onToggleThreads)="toggleThreads()"
                              (onDiscuss)="discuss()"></tm-reactions>

                @if(showThreads){
                    <tm-threads [timelineItem]="mood" #threadsComponent
                                [userInfos]="userInfos"
                                (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
                }
            </div>
        </div>

    <!-- @if (mood.educationalCard){
        <div class="position-absolute mb-md-3 hide-for-mobile top-0 start-100 ms-4"
             [class]="{'hide-for-large-screen': !isOdd, 'hide-oft': isOdd }">
            <tm-educational-card
                    [educCardId]="mood.educationalCard"
                    [threadComponent]="getThreadsComponent"></tm-educational-card>
        </div>
    } -->

    @if(mood.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="mood.managerPanel"
                              [reviewed]="mood.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
</div>
}